import { createTheme } from "@mui/material";

export default createTheme({
  palette: {
    mode: 'light',
  },
});